import React from 'react';
import SettingsPage from '../../components/settings/SettingsPage';

const sections = [
    {
        key: 'contact',
        titleEn: 'Contact',
        titleAr: 'بيانات التواصل',
        descriptionEn: 'How customers reach support.',
        descriptionAr: 'كيف يتواصل العملاء مع الدعم.',
    },
    {
        key: 'social',
        titleEn: 'Social media',
        titleAr: 'وسائل التواصل الاجتماعي',
    },
    {
        key: 'address',
        titleEn: 'Business address',
        titleAr: 'العنوان',
    },
];

const ContactSettings = () => (
    <SettingsPage
        titleEn="Contact Settings"
        titleAr="بيانات التواصل"
        descriptionEn="Support email, phone numbers, social links and physical address shown across the storefront."
        descriptionAr="بريد الدعم، أرقام الهواتف، روابط السوشيال ميديا، والعنوان الفعلي الذي يظهر في الواجهة."
        sections={sections}
    />
);

export default ContactSettings;
